import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getCompanyInvoice() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllInvoiceByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllInvoice(page, limit, search) {
    try {
        let url = `/usermgmt/fetchAllInvoiceByReportingRoleUsers`;
        if (page && limit) {
            url += `?page=${page}&limit=${limit}`;
            if (search) url += `&search=${search}`;
        }
        const response = await getAxiosInstance().get(url, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchInvoiceByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllInvoiceByDealId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findOneByInvoice(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByInvoice/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteInvoice(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteInvoice/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createInvoice(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createInvoice`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateInvoice(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateInvoice/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    getCompanyInvoice,
    FetchInvoiceByDeal,
    fetchAllInvoice,
    findOneByInvoice,
    deleteInvoice,
    updateInvoice,
    createInvoice
}